<template src="./clienti.html"></template>

<script>
import FilePreventivi from "@/components/dialog/FileUpload.vue";

import {
  get_clienti,
  get_noteClienti,
  get_schedaAnagrafica,
  /* get_clientiAttivi, */
} from "@/api/api.agenti.js";

import NoteCliente from "@/components/dialog/NoteCliente";
import NuovaAnagrafica from "@/components/dialog/NuovaAnagrafica";
import DialogFile from "@/components/dialog/file/DialogFile.vue";

export default {
  components: {
    NoteCliente,
    DialogFile,
    NuovaAnagrafica,
    FilePreventivi,
  },

  props: {
    role: { type: String, default: "" },
  },

  data: () => ({
    dati: [],

    headers: [{ text: "Cliente", align: "center", value: "ClRagSoc" }],

    search: "",
    /*  pagination: {
       rowsPerPage: 250,
       sortBy: "ClRagSoc",
     }, */

    current_key: "",
    noteCliente: [],
    codClienteSel: "",

    dialog: false,
    idNota: 0,
    numeroRighe: 0,
    anaAttive: 0,

    dialogFile: false,
    filePromo: [],

    dialogNuovaAnagrafica: false,
    dialogUpload: false,

    messaggioAlert: "",
    filtroFile: ".pdf",
    paginaUpload: "agenti",

    page: 1,
    pageCount: 0,
    itemsPerPage: 250,

    expanded: [],
    singleExpand: false,
    rowClickedData: [],
    selectedRow: {},
  }),

  methods: {
    async caricaDati() {
      // Reset
      this.dati = [];
      this.dialogFile = false;
      try {
        let par = "";
        let userSwitch = this.$store.getters["user/getUserSwitch"];
        if (userSwitch.Codice) {
          if (userSwitch.Tipo == "Cliente")
            par += "singolo/" + userSwitch.Codice;
          else par = userSwitch.Codice;
        }

        let res = await get_clienti(par);
        this.dati = res.data;
        //commentato perché va in errore
        /* if (this.dati != null && this.dati.length >= 0)
          this.numeroRighe = this.dati.length; */
        /* let res2 = await get_clientiAttivi();
        console.log(res2); */
      } catch (error) {
        console.log(error);
      }
    },

    setCliente(props) {
      this.selectedRow = props;
      /* props.expanded = !props.expanded;

      if (!props.expanded) return;

      this.codClienteSel = props.ClCodCli;

      this.caricaNote(); */
    },

    rowClicked(props) {
      this.rowClickedData = props;
      this.expanded = [];
      props.expanded = !props.expanded;
      if (!props.expanded) {
        this.ResetExpanded();
        return;
      }
      this.expanded.push(props);
      this.codClienteSel = props.ClCodCli;
      this.caricaNote();
    },

    ResetExpanded() {
      this.dati.forEach((el) => {
        el.expanded = false;
      });
    },

    async caricaNote() {
      // Reset
      this.noteCliente = [];

      if (this.current_key != 2) return;

      let res = await get_noteClienti(this.codClienteSel);
      this.noteCliente = res.data;
    },

    insNote(id) {
      this.idNota = id;

      this.dialog = true;
    },

    closeDialog() {
      this.dialog = false;
    },

    apriDocumento(file) {
      window.open(file, "_blank");
    },

    apriPdfSconti(elencoFile) {
      //se c'e' solo un file pdf lo apro altrimenti visualizzo la dialog di scelta
      if (elencoFile.length == 1) {
        this.apriDocumento(elencoFile[0].Percorso);
        return;
      }
      this.filePromo = elencoFile;
      this.dialogFile = true;
    },

    chiudiDialogFile() {
      this.dialogFile = false;
    },

    async apriNuovaAnagrafica() {
      let res = await get_schedaAnagrafica();
      if (res.data != null && res.data != "") window.open(res.data, "_blank");
    },

    chiudiNuovaAnagrafica() {
      this.dialogNuovaAnagrafica = false;
    },

    caricaFileAnagrafica() {
      this.$root.$wait.open();
      this.messaggioAlert =
        "Caricamento file pdf compilato per nuova anagrafica";
      this.dialogUpload = true;
      this.$root.$wait.close();
    },

    chiudiDialogFileA() {
      this.dialogUpload = false;
    },
  },

  async mounted() {
    //aspetto qualche millisecondo cosi vue carica i dati dell'utente nello storage
    await this.$functions.delay(500);
    this.caricaDati();
  },

  computed: {
    userSwitch: function () {
      return this.$store.getters["user/getUserSwitch"];
    },
  },

  watch: {
    current_key(newValore, oldValore) {
      this.caricaNote();
    },

    userSwitch() {
      this.caricaDati();
    },
  },
};
</script>

<style scoped>
table.v-table thead tr {
  background: #eb74a9;
  border-bottom: 0px !important;
}

table.v-table th:nth-last-child(1) {
  border-radius: 7px 7px 7px 7px;
}
</style>
